import Immutable from 'immutable';
import RecommendationItem from './model';

const reviver = ([key, val]) => {
  switch (key) {
    case 'id':
      return [key, `${val}`];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

const create = (data) => new RecommendationItem(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/SkillRecommendation/RecommendationItem/create.js